<template>
  <div class="mt-6">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Procesos</h1>
      </div>
    </div>

    <div class="mt-8 grid grid-cols-1 gap-y-6">
      <div class="flex border rounded-lg bg-white py-4 px-1 md:px-6">
        <div class="basis-5/6">
          <h3 class="font-bold text-lg text-indigo-600">
            Mango 2021
            <span
              class="bg-green-500 rounded-full px-2 py-0.5 text-white text-sm font-normal"
            >
              Mango
            </span>
          </h3>
          <div class="grid sm:grid-cols-3 pt-4">
            <h4>
              <span class="text-gray-500 font-medium">Ingresado: </span>
              <strong class="text-gray-600">10,000 Jabas de 19 Kg</strong>
            </h4>
            <h4>
              <span class="text-gray-500 font-medium">Procesado: </span>
              <strong class="text-gray-600">200,000 Kg</strong>
            </h4>
            <h4>
              <span class="text-gray-500 font-medium">Empaques: </span>
              <strong class="text-gray-600">47,600 Cajas de 4.2 Kg</strong>
            </h4>
          </div>
        </div>
        <div class="basis-1/6 flex flex-col justify-center gap-y-2">
          <h3 class="col-span-1 text-gray-600">
            <i class="fa-solid fa-calendar text-gray-500 pr-2"></i>
            Ene 2021 - Mar 2021
          </h3>
          <button
            class="border-2 border-blue-500 text-blue-600 font-medium p-3 rounded-full hover:bg-blue-500 hover:text-white"
            @click="goToProcess(1, 1)"
          >
            Ver detalles
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePackingHouse",
  components: {},
  data() {
    return {};
  },
  props: {},
  created() {},
  computed: {},
  methods: {
    goToProcess(organization_id, process_id) {
      this.$router.push({
        name: "oq_packing_house_basic_production_process_path",
        params: { organization_id: organization_id, process_id: process_id }
      });
    }
  },
  watch: {}
};
</script>
